<template>
  <div class="login-container">
    <vue-particles
        color="#708090"
        :particleOpacity="0.7"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="4"
        linesColor="#708090"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="lizi"
      >
    </vue-particles>
    <div class="login-box">
      <div class="title-box">
        <div class="title">管理员登陆</div>
      </div>
      <div class="edit-main">
        <div class="edit-box">
          <img class="icon" src="../assets/images/ic_login_account.png">
          <div class="boder-one"/>
          <input v-model.trim="body.account" class="input" placeholder="请输入账号">
        </div>
        <div class="edit-box">
          <img class="icon" src="../assets/images/ic_login_password.png">
          <div class="boder-one"/>
          <input v-model.trim="body.password" class="input" type="password" placeholder="请输入密码">
        </div>
        <div class="verify-box">
          <div class="edit-box">
            <img class="icon" src="../assets/images/ic_login_check_code.png">
            <div class="boder-one"/>
            <input
              v-model.trim="inputCode"
              class="input"
              style="width: 0"
              placeholder="请输入验证码"
              maxlength="4"
            >
          </div>
          <img class="img-verify" arc="code" id="code" @click="event().onVerifyImgClicked()">
        </div>
        <el-button type="primary" class="login-btn" @click="event().checkLogin()">登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import PermissionList from '../configs/permissionList'
import { createMenuList } from '../filters/index'
export default {
  data() {
    return {
      body: {
        account: '',
        password: ''
      },
      inputCode: '',
      code: ''
    }
  },
  mounted() {
    this.handler().refreshCode()
  },
  methods: {
    event() {
      return {
        // 登陆校验
        checkLogin: () => {
          if (!this.handler().varifybody()) return
          this.$store.dispatch('user/login', this.body)
            .then(res => {
              sessionStorage.setItem('userName', this.$store.getters.name)
              
              const list = createMenuList(res.data.permissionList)
              //添加按钮级别权限
              this.$store.dispatch('user/clearAccess', [])
              this.accessBtnList(res.data.permissionList)
              sessionStorage.setItem('btnAccessList', JSON.stringify(this.$store.getters.access))
              sessionStorage.setItem('menuList', JSON.stringify(list))
              this.$router.push({ path: '/layout' })
            })
        },
        // 获取验证码
        onVerifyImgClicked: () => {
          this.handler().refreshCode()
        }
      }
    },
    handler() {
      return {
        refreshCode: () => {
          // eslint-disable-next-line no-undef
          const res = verifyCode()
          const img = document.getElementById('code')
          img.src = res.dataURL
          this.code = res.code
          // this.inputCode = res.code
        },
        // 登陆校验
        varifybody: () => {
          if (!this.body.account) {
            this.$message({
              message: '请输入账号',
              type: 'warning'
            })
            return false
          }
          if (!this.body.password) {
            this.$message({
              message: '请输入密码',
              type: 'warning'
            })
            return false
          }
          if (!this.inputCode) {
            this.$message({
              message: '请输入验证码',
              type: 'warning'
            })
            return false
          }
          if (this.inputCode.toUpperCase() !== this.code.toUpperCase()) {
            this.$message({
              message: '验证码错误',
              type: 'warning'
            })
            return false
          }
          return true
        }
      }
    },
    accessBtnList(list){
      list.forEach(item => {
        if (item.children && item.children.length) {
          this.accessBtnList(item.children)
        } else {
          if (item.subName !== '') {
            this.$store.dispatch('user/addBtnAccess', item)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
$bg:#f3f3f3;
.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  .login-box{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 371px;
    height: 351px;
    margin: auto auto;
    background-color: #ffffff;
    .title-box{
        width: 100%;
        height: 58px;
        background: #409eff;
        .title {
            margin: 0 21px;
            line-height: 58px;
            font-size: 16px;
            color: #ffffff;
        }
    }
    .edit-main {
        padding: 18px 17px 28px;
        .edit-box{
            display: flex;
            align-items: center;
            width: 312px;
            height: 45px;
            margin-bottom: 16px;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid rgba(32,53,128,0.16);
            img.icon {
                width: 17px;
                margin-right: 14px;
            }
            div.boder-one {
                width: 0px;
                height: 24px;
                border-left: 1px solid rgba(216, 221, 233, 1);
            }
            input.input {
                padding: 0 14px;
                flex: 1;
                outline: none;
                border: none;
                font-size: 12px;
            }
        }
    }
    .verify-box {
        position: relative;
        height: 40px;
        width: 336px;
        .edit-box {
            width: 160px;
            float: left;
            display: flex;
            align-items: center;
            height: 40px;
            margin: 0 auto;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid rgba(32, 53, 128, 0.16);
            img.icon {
              width: 17px;
              margin-right: 14px;
            }
            div.boder-one {
              width: 0px;
              height: 24px;
              border-left: 1px solid rgba(216, 221, 233, 1);
            }
            input.input {
              flex: 1;
              outline: none;
              border: none;
            }
        }
        img#code.img-verify {
            float: left;
            width: 100px;
            height: 40px;
            margin-left: 20px;
        }
    }

    .login-btn {
        margin: 27px auto 8px auto;
        width: 336px;
        height: 45px;
        border-radius: 3px;
        color: #ffffff;
    }
}
}
</style>
